module.exports = __webpack_public_path__ + "static/ogrod-wypoczynek_thumb-620ac3c3b572e5b22291856918d85093.jpg";